import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { DialogProgrammatic as Dialog } from "buefy";
export interface DataManagementImport {
  id?: number;
  customer: number;
  importTypes: string;
  period: string;
  document: File;
  comments: string;
}
function dateFormatter(dt: any) {
  if (dt == "Invalid Date") {
    return null;
  }
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export default class DataManagementImportService {
  private httpClient = makeHttpClient();
  private resolveTenantId(customerId: any) {
    if (customerId === 0 || customerId === "0") {
      return 0;
    }

    if (Array.isArray(customerId)) {
      const publicCustomer = customerId.find(
        item => item?.id === 0 || item?.name === "Public"
      );
      if (publicCustomer) {
        return 0;
      }

      const firstWithId = customerId.find(
        item => item?.id !== undefined && item?.id !== null
      );
      return firstWithId?.id ?? customerId;
    }

    if (customerId && typeof customerId === "object") {
      if (customerId.id !== undefined && customerId.id !== null) {
        return customerId.id;
      }
      if (
        customerId.customer_id !== undefined &&
        customerId.customer_id !== null
      ) {
        return customerId.customer_id;
      }
      if (customerId.value !== undefined && customerId.value !== null) {
        return customerId.value;
      }
      if (customerId.name === "Public") {
        return 0;
      }
    }

    return customerId;
  }
  create(form: any, isRawData: boolean) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: form.customer.id
      }
    };
    const data = new FormData();
    data.append("customer_id", form.customer.id);
    data.append("import_types", form.importType.name);
    data.append("period", form.period);
    data.append("comments", form.comments == null ? "" : form.comments);
    data.append("is_replaced_td", form.isReplacedTD);
    data.append("is_add_more_td", form.isAddedMoreTD);
    const documents = form.document;
    if (documents) {
      for (let i = 0; i < documents.length; i++) {
        data.append("document" + i, documents[i]);
      }
    }
    let url = env.dataManagementImportUrl;
    if (form.importType.name == "Products") {
      url = url + `product/data/`;
    } else {
      url = url + `transaction/data/`;
    }
    if (isRawData) {
      url = env.dataManagementReImportUrl + `raw/data/`;
    }
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(url, data, headers)
    );
  }

  importRawData(form: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: form.customer.id
      }
    };
    const data = new FormData();
    data.append("customer_id", form.customer.id);
    data.append("import_type", form.importType.name);
    data.append("period", form.period);
    data.append("is_import_existing_mapping", form.isImportExistingMapping);
    data.append("comments", form.comments == null ? "" : form.comments);
    data.append("replace_existing_data", form.isReplacedTD);
    data.append("add_to_existing_data", form.isAddedMoreTD);

    const documents = form.document;
    if (documents) {
      for (let i = 0; i < documents.length; i++) {
        data.append("document" + i, documents[i]);
      }
    }
    const url = env.conversionToolUrl + `import-raw-data/`;
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(url, data, headers)
    );
  }
  mapRawFilesHeaderData(
    fileHeaderId: any,
    customerId: any,
    formData: any,
    importId: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: this.resolveTenantId(customerId)
      }
    };
    const data = new FormData();
    data.append("cdf_mapping", JSON.stringify(formData));
    data.append("raw_file_header_id", fileHeaderId);
    const url =
      env.conversionToolUrl + `raw-file-header/?raw_data_import_id=` + importId;
    return _unwrapAxiosResponse(
      this.httpClient.put<DataManagementImport>(url, data, headers)
    );
  }
  additionalDataManipulation(
    fileHeaderId: any,
    customerId: any,
    formulaData: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: this.resolveTenantId(customerId)
      }
    };
    const data = new FormData();
    data.append("formula_data", JSON.stringify(formulaData));
    data.append("raw_file_header_id", fileHeaderId);
    const url = env.conversionToolUrl + `raw-data-manipulation/`;
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(url, data, headers)
    );
  }
  getRawFilesHeaderData(importId: any, customerId: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: this.resolveTenantId(customerId)
      }
    };
    const url =
      env.conversionToolUrl + `raw-file-header/?raw_data_import_id=` + importId;
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(url, headers)
    );
  }
  getRawFileData(customerId: any, raw_file_header_id: any, query: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: this.resolveTenantId(customerId)
      }
    };
    const url =
      env.conversionToolUrl +
      `raw-file-data/?raw_file_header_id=` +
      raw_file_header_id +
      "&" +
      query;
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(url, headers)
    );
  }
  addMoreData(
    importId: any,
    importType: any,
    customerId: any,
    importDocuments: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: this.resolveTenantId(customerId)
      }
    };

    const data = new FormData();
    data.append("import_id", importId);
    data.append("customer_id", customerId);

    for (let i = 0; i < importDocuments.length; i++) {
      data.append("document" + i, importDocuments[i]);
    }

    let url = env.dataManagementReImportUrl;
    if (importType == "Products") {
      url = url + `product/data/`;
    } else {
      url = url + `transaction/data/`;
    }
    return _unwrapAxiosResponse(
      this.httpClient.put<DataManagementImport>(url, data, headers)
    );
  }
  dataImport(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(
        env.cdfProductUrl + `${cdfId}/generate_cdf/`,
        data
      )
    );
  }
  getAllImport(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.dataManagementImportUrl + `workflow/?` + query
      )
    );
  }

  getBarcodeMatchingData(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.dataManagementTempUrl + `barcode-matching/?page_size=50&` + query
      )
    );
  }

  bulkOperation(
    selectedRows: any,
    isSelectedAll: any,
    action: any,
    query: any
  ) {
    const data = new FormData();
    if (selectedRows.length == 0) {
      throw new Error("Please select at least one record.");
    } else {
      selectedRows.map((id: any) => {
        data.append("id", "" + id);
      });
    }
    data.append("match_type", action);
    data.append("all", isSelectedAll);
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(
        env.dataManagementTempUrl + `barcode-matching/bulk-update/?` + query,
        data
      )
    );
  }

  exportBarcodeMatching(ids: number[], isCheckedAll: boolean, query: any) {
    const params = new URLSearchParams();
    ids.map(id => {
      params.append("id", "" + id);
    });
    params.append("isCheckedAll", "" + isCheckedAll);

    const url = `${
      env.dataManagementTempUrl
    }barcode-matching/export/?${query}&${params.toString()}`;

    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "CentralMatching.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(error => {
        Dialog.alert({
          title: "Download Error !",
          message: "Download failed. Please try again or contact support.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      });
  }

  getAllIRawDatamport(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.conversionToolUrl + `import/workflow/?` + query
      )
    );
  }
  getImportedRawDataById(id: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.conversionToolUrl + `import/workflow/${id}/`
      )
    );
  }
  getImportById(id: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.dataManagementImportUrl + `workflow/${id}/`
      )
    );
  }

  updateImportStatus(customerId: number, importId: number, status: string) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    const data = new FormData();
    data.append("status", status);
    const url = env.dataManagementImportUrl + `workflow/${importId}/`;
    return _unwrapAxiosResponse(
      this.httpClient.patch<DataManagementImport>(url, data, headers)
    );
  }

  addSingleProductData(customer: any, data: any, selectedProductId: any) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        tenant: customer
      }
    };
    const url = env.dataManagementTempUrl + `product/create/`;

    // Check if we have a selectedProductId or if the product ID is in the data
    const productId = selectedProductId || data?.["PRODUCT SHEET"]?.id;

    if (productId) {
      // Use PUT for edit mode
      if (!data.product_id) {
        data.product_id = productId;
      }
      return _unwrapAxiosResponse(
        this.httpClient.put<DataManagementImport>(url, data, headers)
      );
    } else {
      // Use POST for create mode
      return _unwrapAxiosResponse(
        this.httpClient.post<DataManagementImport>(url, data, headers)
      );
    }
  }

  getOrUpdateProductData(
    customer: any,
    stream: any,
    import_id: number,
    dataType: any,
    query: any,
    data: any,
    isEdit: boolean,
    filterValues: any = {},
    isManualMatching = false
  ) {
    const headers = {
      headers: {
        "Content-Type": isEdit ? "application/json" : "multipart/form-data",
        tenant: customer
      }
    };

    let stream_url = "";

    switch (stream) {
      case "BATT":
        if (isManualMatching) {
          stream_url = "manual/matching/product/batt";
        } else {
          stream_url = "product/batt";
        }
        break;
      case "WEEE":
        if (isManualMatching) {
          stream_url = "manual/matching/product/weee";
        } else {
          stream_url = "product/weee";
        }
        break;
      case "PACK":
        if (isManualMatching) {
          stream_url = "manual/matching/product/pack";
        } else {
          stream_url = "product/pack";
        }
        break;
      case "COPY":
        if (isManualMatching) {
          stream_url = "manual/matching/product/copy";
        } else {
          stream_url = "product/copy";
        }
        break;
      case "BUNDLE INFORMATION":
        if (isManualMatching) {
          stream_url = "manual/matching/product/bundle";
        } else {
          stream_url = "product/bundle";
        }
        break;
      default:
        if (isManualMatching) {
          stream_url = "manual/matching/product";
        } else {
          stream_url = "product";
        }
    }
    if (dataType === "isTemp") {
      if (query.length > 0) {
        if (query.indexOf(import_id) === -1) {
          stream_url = `temp/${stream_url}/?import_id=${import_id}` + query;
        } else {
          stream_url = `temp/${stream_url}/?` + query;
        }
      } else {
        stream_url = `temp/${stream_url}/?import_id=${import_id}` + query;
      }
    } else {
      stream_url = stream_url + "/?" + query;
    }
    if (isEdit) {
      data["valid_to"] = dateFormatter(data.valid_to);
      data["valid_from"] = dateFormatter(data.valid_from);
      return _unwrapAxiosResponse(
        this.httpClient.put<DataManagementImport>(
          env.dataManagementTempUrl + stream_url,
          data,
          headers
        )
      );
    } else {
      return _unwrapAxiosResponse(
        this.httpClient.get<DataManagementImport>(
          env.dataManagementTempUrl + stream_url,
          { params: filterValues, headers: headers.headers }
        )
      );
    }
  }
  getTransactionData(customer: any, query: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        "/data/management/transaction/?" + query,
        headers
      )
    );
  }
  getTempTransactions(customer: any, import_id: number, query: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.dataManagementTempUrl +
          `temp/transaction/?import_id=${import_id}` +
          query,
        headers
      )
    );
  }

  getProductAutoValidationMsg(importId: any, customerId: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.dataManagementTempUrl +
          `import/autovalidation/msg/?import_id=` +
          importId +
          "&customer_id=" +
          customerId
      )
    );
  }

  getAdditionalDropdowns(customerId: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<DataManagementImport>(
        env.dataManagementTempUrl +
          "import/autovalidation/msg/?customer_id=" +
          customerId
      )
    );
  }

  validateOrDiscardData(
    importId: any,
    customerId: any,
    workflow_status: any,
    import_type: any,
    is_raw_import: any
  ) {
    let url;
    if (import_type == "Products") {
      url = env.dataManagementTempUrl + `workflow/validate/products/`;
    } else {
      url = env.dataManagementTempUrl + `workflow/validate/transactions/`;
    }

    const data = new FormData();
    data.append("customer_id", customerId);
    data.append("workflow_id", importId);
    data.append("workflow_status", workflow_status);
    data.append("is_raw_import", is_raw_import);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(url, data, headers)
    );
  }
  validateOrDiscardRawData(
    importId: any,
    customerId: any,
    workflow_status: any
  ) {
    const url = env.conversionToolUrl + `raw-data/validate/workflow/`;

    const data = new FormData();
    data.append("customer_id", customerId);
    data.append("raw_data_import_id", importId);
    data.append("workflow_status", workflow_status);

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<DataManagementImport>(url, data, headers)
    );
  }

  downloadImportedFile(importId: number, fileName: any) {
    //const encodedFileName = encodeURIComponent(fileName);
    const url = encodeURI(
      `${env.dataManagementTempUrl}export/cdf/file/?id=${importId}&file_name=${fileName}`
    );
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Download not possible",
          message:
            "There was an error downloading the imported file. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }

  downloadRawDataFile(importId: number, fileName: any) {
    //const encodedFileName = encodeURIComponent(fileName);
    const url = encodeURI(
      `${env.conversionToolUrl}export/raw/file/?id=${importId}&file_name=${fileName}`
    );
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Download not possible",
          message:
            "There was an error downloading the raw data file. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }

  exportProductSheetWithError(id: number) {
    const url = encodeURI(
      `${env.dataManagementTempUrl}export/product/error/document/?import_id=${id}`
    );
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const disposition = response.headers["content-disposition"];
        const link = document.createElement("a");
        const filename = decodeURI(
          disposition.replace("attachment; filename=", "")
        );
        link.href = downloadUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There was an error exporting the product sheet with errors. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }

  bulkProductEdit(
    importId: any,
    customerId: any,
    tempProduct: boolean,
    formProductData: any,
    dependentField: string,
    stream: string,
    selectedRows: any,
    query: string
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customerId
      }
    };
    const data = new FormData();

    if (typeof selectedRows !== "boolean") {
      const selectedRowsId: any = [];
      selectedRows.forEach(function(value: any) {
        selectedRowsId.push(value.id);
      });
      data.append("product_id", selectedRowsId);
    } else {
      data.append("product_id", "all");
    }
    data.append("stream", stream);
    data.append("customer_id", customerId);
    if (importId) data.append("import_id", importId);
    data.append("field", formProductData["field"]);

    if (
      formProductData["field"].trim() == "valid_from" ||
      formProductData["field"].trim() == "valid_to"
    ) {
      const value: any = formProductData["value"].toLocaleDateString("fr-CA");

      data.append("value", value);
    } else {
      data.append("value", formProductData["value"]);
    }
    data.append(
      "dependent_field_value",
      formProductData["dependentFieldValue"]
    );
    data.append("dependent_field", dependentField);

    let url = env.dataManagementTempUrl;
    if (tempProduct) {
      url = url + `product/data/temp/bulk/edit/`;
    } else {
      url = url + `product/data/bulk/edit/`;
    }

    if (query) {
      url = `${url}?` + query;
    }

    return _unwrapAxiosResponse(this.httpClient.put(url, data, headers));
  }

  dataCompletion(
    importId: any,
    tempProduct: any,
    dataCompletionRules: string,
    stream: string,
    selectedRows: any,
    query: string,
    customerId: any
  ) {
    const data = new FormData();
    if (typeof selectedRows !== "boolean") {
      const selectedRowsId: any = [];
      selectedRows.forEach(function(value: any) {
        selectedRowsId.push(value.id);
      });
      data.append("product_id", selectedRowsId);
    } else {
      data.append("product_id", "all");
    }
    data.append("filtered_sheet", stream);
    data.append("is_temp", tempProduct);
    if (customerId && customerId > 0) {
      data.append("customer_id", customerId);
    }
    if (importId) data.append("cdf_import_id", importId);
    data.append("data_completion_rules", JSON.stringify(dataCompletionRules));
    let url = "/data/completion/apply/";
    if (query) {
      url = `${url}?` + query;
    }

    return _unwrapAxiosResponse(this.httpClient.put(url, data));
  }

  dataRevert(customerId: any, importId: any) {
    const data = new FormData();
    if (customerId && customerId > 0) {
      data.append("customer_id", customerId);
    }
    if (importId) data.append("cdf_import_id", importId);
    const url = "/data/completion/revert/";
    return _unwrapAxiosResponse(this.httpClient.post(url, data));
  }
}
